<header></header>
<div class="post-login-1">
    <div class="post-login-1-col-1 h-100">
        <left-panel activeTab="5"></left-panel>
    </div>
    <div class="post-login-1-col-2">
        <section class="notification-page h-100">
            <grid-row class="justify-content-center align-content-center h-100">
                <grid-col class="h-100">
                    <grid-row class="h-100">
                        <grid-col col="4" mobile="12" class="border-right border-color-900 pt-25 pb-25 pl-25 h-100">
                            <div class="inside-child-scroll">
                                <div class="fixed-item pr-25">
                                    <div class="font-600  font-size-20px color-010">
                                        {{"Inbox" | translate }}
                                    </div>
                                </div>
                                <div class="scroll-item notification-tab">
                                    <div class="font-600 font-size-14px line-h-18 color-base-500 mt-20 mb-20">
                                        {{ "Today" | translate}}
                                    </div>
                                    <div *ngFor="let items of IndoxMessageList">
                                   

                                    <div class="font-600 font-size-12px line-h-18 color-base-500 mt-20 mb-20">
                                        {{items?.label}}
                                    </div>
                                    <div class="border border-color-900 bg-base-100 br-12 mt-15 mb-15" *ngFor="let item of items?.messages; let i=index">
                                        <grid-row
                                            class="justify-content-between align-item-top position-relative notification-tab-item"
                                            [ngClass]="activeNoti == item?.id ? 'active' : ''" (click)="changeNoti(item)">
                                            <grid-col col="10">
                                                <div class="font-400 font-size-12px color-base-400">
                                                   {{item?.createdOn | date:"hh:mm a"}}
                                                </div>
                                                <div class="font-400 font-size-14px line-h-22 color-base-700 mt-5">
                                                    {{item?.title}}
                                                </div>
                                                <div class="font-400 font-size-12px color-base-500 line-h-18 mt-5">
                                                    {{item?.message.split("\n")[0]}}
                                                </div>
                                                <span class="notification-2" *ngIf="!item?.isRead"></span>
                                            </grid-col>
                                        </grid-row>
                                    </div>
                                         
                                </div>
                                </div>
                            </div>
                        </grid-col>
                        <grid-col col="8" mobile="12" class="p-25 h-100">
                            <grid-row class="justify-content-center align-content-center h-100">
                                <grid-col col="12" class="h-100">
                                    <div class="box-shadow br-12 bg-base-100 border border-color-900 h-100 p-40">
                                        <ng-container>
                                            <grid-row class="justify-content-between align-item-center">
                                                <grid-col col="auto">
                                                    <span class="font-600 font-size-12px color-base-400 mr-16">
                                                        {{selectedItem?.createdOn | date:"dd-MMM-yyyy"}}
                                                    </span>
                                                    <span class="font-600 font-size-12px color-base-400">
                                                        {{selectedItem?.createdOn | date:"hh:mm a"}} </span>
                                                </grid-col>
                                                <grid-col col="auto" *ngIf="this.activeNoti!==null" (click)="deleteMessage(selectedItem)">
                                                    <ng-icon iconClass="icon-delete-blue link" width="24"
                                                        height="24"></ng-icon>
                                                </grid-col>
                                            </grid-row>
                                            <div class="font-600 font-size-20px line-h-28 color-010 mt-10">
                                                {{selectedItem?.title}}
                                            </div>
                                            <div class="font-400 font-size-14 line-h-20 color-base-400 mt-20" *ngIf="selectedItem?.message">
                                               {{selectedItem?.message?.split("\n\r")[0]}}
                                            </div>
                                            <div class="font-400 font-size-14 line-h-20 color-base-400 mt-20" *ngIf="selectedItem?.message">
                                                {{selectedItem?.message?.split("\n\r")[1]?.split('\r\n')[0]}}
                                                <br>
                                                {{selectedItem?.message?.split("\n\r")[1]?.split('\r\n')[1]}}
                                             </div>
                                            <div class="font-400 font-size-14 line-h-20 color-base-400 mt-15" *ngIf="selectedItem?.message">
                                                {{selectedItem?.message?.split("\n\r")[2]}}
                                               <br>
                                                {{selectedItem?.message?.split("\n\r")[3] }}
                                            </div>
                                            <div class="font-400 font-size-14 line-h-20 color-base-400 mt-15 " *ngIf="selectedItem?.message">
                                                {{selectedItem?.message?.split("\n\r")[4]}}
                                            </div>
                                        </ng-container>                    

                                        <!-- Empty state -->
                                        <grid-row class="align-item-center text-align-center h-100"
                                            *ngIf="activeNoti==null">
                                            <grid-col>
                                                <ng-icon iconClass="icon-notification-emptystate" width="160"
                                                    height="160"></ng-icon>
                                                <div class="font-600 font-size-20px line-h-28 color-base-700">
                                                    {{"SelectItemRead" | translate}}
                                                </div>
                                                <div class="font-400 font-size-14px line-h-22 color-base-500">
                                                    {{"NothingSelected" | translate}}
                                                </div>
                                            </grid-col>
                                        </grid-row>
                                    </div>
                                </grid-col>
                            </grid-row>
                        </grid-col>
                    </grid-row>
                </grid-col>
            </grid-row>
        </section>
    </div>
</div>